import EyeIcon from 'components/ReusableComponents/Icons/Eye'
import TrashIcon from 'components/ReusableComponents/Icons/Trash'
import InviteEmailDesignCardIconButton from 'features/InviteEmailDesign/InviteEmailDesignCardIconButton'
import InviteEmailDesignTemplatePreview from 'features/InviteEmailDesign/InviteEmailDesignTemplatePreview'
import { buildInviteEmailDesignEditPath } from 'features/InviteEmailDesign/inviteEmailDesignTemplateHelpers'
import { useInviteEmailDesignPreview } from 'features/InviteEmailDesign/useInviteEmailDesignPreview'
import { Link } from 'react-router-dom'

import styles from './InviteEmailDesign.module.scss'

const InviteEmailDesignTemplateCard = ({ template, onPreview, onDelete }) => {
  const editPath = buildInviteEmailDesignEditPath(template.id)
  const { previewHtml, layoutLabel, isLoading, hasError } = useInviteEmailDesignPreview(template.id)

  return (
    <article
      className={[
        styles.templateCard,
        template.isActive ? styles.templateCardActive : ''
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <Link className={styles.templateCardLink} to={editPath} aria-label={`Edit ${template.name}`}>
        <div className={styles.templateCardMedia}>
          <InviteEmailDesignTemplatePreview
            variant="card"
            previewHtml={previewHtml}
            isLoading={isLoading}
            hasError={hasError}
          />
          <span className={styles.templateCardEditHint}>Edit design</span>
        </div>

        <div className={styles.templateCardBody}>
          <div className={styles.templateCardHeader}>
            <span className={styles.templateCardName}>{template.name}</span>
            {template.isActive && <span className={styles.activeBadge}>Active</span>}
          </div>
        </div>
      </Link>

      <div className={styles.templateCardFooter}>
        {layoutLabel ? (
          <span className={styles.templateMeta}>Layout: {layoutLabel}</span>
        ) : (
          <span className={styles.templateMetaPlaceholder} aria-hidden="true" />
        )}

        <div className={styles.templateCardActions}>
          <InviteEmailDesignCardIconButton
            label="Preview"
            onClick={event => {
              event.preventDefault()
              event.stopPropagation()
              onPreview(template)
            }}
          >
            <EyeIcon width={18} height={18} fill="currentColor" />
          </InviteEmailDesignCardIconButton>
          {!template.isActive && (
            <InviteEmailDesignCardIconButton
              label="Delete"
              variant="danger"
              onClick={event => {
                event.preventDefault()
                event.stopPropagation()
                onDelete(template)
              }}
            >
              <TrashIcon width={18} height={18} fill="currentColor" />
            </InviteEmailDesignCardIconButton>
          )}
        </div>
      </div>
    </article>
  )
}

export default InviteEmailDesignTemplateCard
